import { render, staticRenderFns } from "./MaglieFromPivot.vue?vue&type=template&id=5c2d9171&scoped=true&"
import script from "./MaglieFromPivot.vue?vue&type=script&lang=js&"
export * from "./MaglieFromPivot.vue?vue&type=script&lang=js&"
import style0 from "./MaglieFromPivot.vue?vue&type=style&index=0&id=5c2d9171&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2d9171",
  null
  
)

export default component.exports